// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Enterprise Sidebar - Compact Professional Design
   ============================================ */

/* CSS Variables - Simplified Color Scheme */
:root {
  --sidebar-bg: #ffffff;
  --sidebar-bg-hover: #e0f2fe;
  --sidebar-active: #87ceeb;
  --sidebar-active-light: rgba(135, 206, 235, 0.15);
  --sidebar-text: #000000;
  --sidebar-text-muted: #4a5568;
  --sidebar-border: rgba(135, 206, 235, 0.3);
  --sidebar-transition: all 0.2s ease;
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --sidebar-width: 260px; /* Initial sidebar width */
}

/* ============================================
   Mobile Toggle Button
   ============================================ */
.Sidebar_mobileToggle__\\+vi9J {
  display: none;
  position: fixed;
  top: 0.75rem;
  left: 0.75rem;
  z-index: 1001;
  background: var(--light-sky-blue);
  color: white;
  border: none;
  border-radius: 0.375rem;
  padding: 0.5rem;
  cursor: pointer;
  transition: var(--sidebar-transition);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.Sidebar_mobileToggle__\\+vi9J:hover {
  background: #6bb6d4;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.Sidebar_mobileToggle__\\+vi9J:active {
  transform: scale(0.95);
}

@media (max-width: 768px) {
  .Sidebar_mobileToggle__\\+vi9J {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* ============================================
   Mobile Overlay
   ============================================ */
.Sidebar_mobileOverlay__oCEWt {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: Sidebar_fadeIn__JFH-L 0.2s ease-in-out;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

@keyframes Sidebar_fadeIn__JFH-L {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ============================================
   Main Sidebar Container
   ============================================ */
.Sidebar_sidebar__y9l62 {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 260px;
  background: var(--sidebar-bg);
  color: var(--sidebar-text);
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--sidebar-border);
  transition: var(--sidebar-transition);
  z-index: 1000;
  overflow: hidden;
}

.Sidebar_sidebarCollapsed__f57kE {
  width: 70px;
}

/* ============================================
   Sidebar Header
   ============================================ */
.Sidebar_sidebarHeader__VcE0q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0.875rem;
  border-bottom: 1px solid var(--sidebar-border);
  background: var(--sidebar-bg);
  min-height: 60px;
}

.Sidebar_logoSection__Q3vO9 {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  flex: 1 1;
  overflow: hidden;
}

.Sidebar_logoText__aDX9V {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--sidebar-text);
  margin: 0;
  letter-spacing: -0.25px;
  white-space: nowrap;
}

.Sidebar_logoSubtext__bksI3 {
  font-size: 0.6875rem;
  color: var(--sidebar-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.Sidebar_collapseButton__wzb8\\+ {
  background: transparent;
  border: 1px solid var(--sidebar-border);
  color: var(--sidebar-text);
  border-radius: 0.375rem;
  padding: 0.375rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--sidebar-transition);
  min-width: 32px;
  min-height: 32px;
}

.Sidebar_collapseButton__wzb8\\+:hover {
  background: var(--sidebar-bg-hover);
  border-color: var(--light-sky-blue);
}

.Sidebar_collapseButton__wzb8\\+:active {
  transform: scale(0.95);
}

/* ============================================
   Navigation Content
   ============================================ */
.Sidebar_navContent__zSbRD {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.75rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.Sidebar_navContent__zSbRD::-webkit-scrollbar {
  width: 4px;
}

.Sidebar_navContent__zSbRD::-webkit-scrollbar-track {
  background: transparent;
}

.Sidebar_navContent__zSbRD::-webkit-scrollbar-thumb {
  background: var(--sidebar-border);
  border-radius: 2px;
}

.Sidebar_navContent__zSbRD::-webkit-scrollbar-thumb:hover {
  background: var(--light-sky-blue);
}

.Sidebar_navSection__MrBC6 {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  padding: 0 0.625rem;
}

/* ============================================
   Menu Item
   ============================================ */
.Sidebar_menuItem__diVxf {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 0.875rem;
  color: var(--sidebar-text);
  text-decoration: none;
  border-radius: 0.375rem;
  transition: var(--sidebar-transition);
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  overflow: hidden;
}

.Sidebar_menuItem__diVxf::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--light-sky-blue);
  transform: scaleY(0);
  transition: transform 0.2s ease;
}

.Sidebar_menuItem__diVxf:hover {
  background: var(--sidebar-bg-hover);
  color: var(--sidebar-text);
}

.Sidebar_menuItem__diVxf:hover::before {
  transform: scaleY(1);
}

.Sidebar_menuItemActive__kbq3X {
  background: var(--sidebar-active-light);
  color: var(--sidebar-text);
  font-weight: 600;
}

.Sidebar_menuItemActive__kbq3X::before {
  transform: scaleY(1);
}

.Sidebar_menuItemCollapsed__a0lvM {
  justify-content: center;
  padding: 0.625rem;
}

.Sidebar_menuIcon__4MF8g {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 18px;
  color: var(--sidebar-text);
}

.Sidebar_menuItemActive__kbq3X .Sidebar_menuIcon__4MF8g {
  color: var(--light-sky-blue);
}

.Sidebar_menuLabel__U7TaE {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Sidebar_activeIndicator__-Bf-h {
  position: absolute;
  right: 0.625rem;
  width: 6px;
  height: 6px;
  background: var(--light-sky-blue);
  border-radius: 50%;
}

/* ============================================
   Sidebar Section (Accordion)
   ============================================ */
.Sidebar_sidebarSection__tCTA2 {
  margin-bottom: 0.25rem;
}

.Sidebar_sectionHeader__AnQWG {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  padding: 0.625rem 0.875rem;
  background: transparent;
  border: none;
  color: var(--sidebar-text);
  border-radius: 0.375rem;
  cursor: pointer;
  transition: var(--sidebar-transition);
  font-size: 0.875rem;
  font-weight: 600;
  text-align: left;
  position: relative;
}

.Sidebar_sectionHeader__AnQWG:hover {
  background: var(--sidebar-bg-hover);
}

.Sidebar_sectionHeaderExpanded__19YGx {
  background: var(--sidebar-bg-hover);
}

.Sidebar_sectionHeaderCollapsed__EIWaC {
  justify-content: center;
  padding: 0.625rem;
}

.Sidebar_sectionHeader__AnQWG:disabled {
  cursor: default;
}

.Sidebar_sectionIcon__-0twO {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 18px;
  color: var(--sidebar-text);
}

.Sidebar_sectionLabel__bjzdA {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Sidebar_sectionChevron__AfkFz {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  flex-shrink: 0;
  color: var(--sidebar-text-muted);
}

.Sidebar_sectionHeaderExpanded__19YGx .Sidebar_sectionChevron__AfkFz {
  transform: rotate(90deg);
}

.Sidebar_sectionContent__g5zZp {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease;
  padding-left: 0.375rem;
  margin-top: 0.125rem;
}

.Sidebar_sectionContentExpanded__5gZ\\+l {
  max-height: 2000px;
  padding-left: 0.375rem;
}

.Sidebar_sectionContent__g5zZp .Sidebar_menuItem__diVxf {
  padding-left: 2.25rem;
  font-size: 0.8125rem;
  font-weight: 400;
}

.Sidebar_sectionContent__g5zZp .Sidebar_menuItemActive__kbq3X {
  font-weight: 500;
}

/* ============================================
   Sidebar Footer
   ============================================ */
.Sidebar_sidebarFooter__ia3Ij {
  padding: 0.75rem 0.625rem;
  border-top: 1px solid var(--sidebar-border);
  background: var(--sidebar-bg);
}

.Sidebar_logoutButton__hHI1p {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  width: 100%;
  padding: 0.75rem 0.875rem;
  background: var(--light-red);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--sidebar-transition);
}

.Sidebar_logoutButton__hHI1p:hover {
  background: #ff5252;
}

.Sidebar_logoutButton__hHI1p:active {
  transform: scale(0.98);
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .Sidebar_sidebar__y9l62 {
    width: 240px;
  }

  .Sidebar_sidebarCollapsed__f57kE {
    width: 65px;
  }

  .Sidebar_logoText__aDX9V {
    font-size: 1.125rem;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .Sidebar_mobileToggle__\\+vi9J {
    display: flex;
    top: 0.625rem;
    left: 0.625rem;
  }

  .Sidebar_mobileOverlay__oCEWt {
    display: block;
  }

  .Sidebar_sidebar__y9l62 {
    width: 260px;
    max-width: 85vw;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  }

  .Sidebar_sidebarMobileOpen__YVvhL {
    transform: translateX(0);
  }

  .Sidebar_sidebarCollapsed__f57kE {
    width: 260px;
    max-width: 85vw;
  }

  .Sidebar_sidebarHeader__VcE0q {
    padding: 0.875rem 0.75rem;
    min-height: 55px;
  }

  .Sidebar_logoText__aDX9V {
    font-size: 1.125rem;
  }

  .Sidebar_navContent__zSbRD {
    padding: 0.625rem 0;
    -webkit-overflow-scrolling: touch;
  }

  .Sidebar_navSection__MrBC6 {
    padding: 0 0.5rem;
  }

  .Sidebar_menuItem__diVxf {
    padding: 0.75rem 0.875rem;
    font-size: 0.875rem;
    touch-action: manipulation;
  }

  .Sidebar_sectionHeader__AnQWG {
    padding: 0.75rem 0.875rem;
    font-size: 0.875rem;
    touch-action: manipulation;
  }

  .Sidebar_sectionContent__g5zZp .Sidebar_menuItem__diVxf {
    padding-left: 2.5rem;
  }

  .Sidebar_collapseButton__wzb8\\+ {
    min-width: 28px;
    min-height: 28px;
    padding: 0.25rem;
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .Sidebar_sidebar__y9l62 {
    width: 100%;
    max-width: 280px;
  }

  .Sidebar_mobileToggle__\\+vi9J {
    top: 0.5rem;
    left: 0.5rem;
    padding: 0.5rem;
    width: 40px;
    height: 40px;
  }

  .Sidebar_sidebarHeader__VcE0q {
    padding: 0.75rem 0.625rem;
    min-height: 50px;
  }

  .Sidebar_logoText__aDX9V {
    font-size: 1rem;
  }

  .Sidebar_logoSubtext__bksI3 {
    font-size: 0.625rem;
  }

  .Sidebar_navContent__zSbRD {
    padding: 0.5rem 0;
  }

  .Sidebar_menuItem__diVxf {
    padding: 0.625rem 0.75rem;
    font-size: 0.8125rem;
  }

  .Sidebar_sectionHeader__AnQWG {
    padding: 0.625rem 0.75rem;
    font-size: 0.8125rem;
  }

  .Sidebar_logoutButton__hHI1p {
    padding: 0.625rem 0.75rem;
    font-size: 0.8125rem;
  }

  .Sidebar_collapseButton__wzb8\\+ {
    min-width: 24px;
    min-height: 24px;
    padding: 0.25rem;
  }
}

/* ============================================
   Accessibility & Animations
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Focus states for keyboard navigation */
.Sidebar_menuItem__diVxf:focus-visible,
.Sidebar_sectionHeader__AnQWG:focus-visible,
.Sidebar_collapseButton__wzb8\\+:focus-visible,
.Sidebar_logoutButton__hHI1p:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

/* Print styles */
@media print {
  .Sidebar_sidebar__y9l62 {
    display: none;
  }

  .Sidebar_mobileToggle__\\+vi9J {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Sidebar.module.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,iDAAiD;EACjD,uBAAuB;EACvB,6BAA6B;EAC7B,0CAA0C;EAC1C,mCAAmC;EACnC,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,iDAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,qCAAqC;EACrC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,8CAA8C;EAC9C,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,0BAA0B;EAC1B,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;IACb,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,uDAAuD;IACvD,wCAAwC;EAC1C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;AACjD;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,yCAAyC;AACzC;;;;EAIE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================\n   Enterprise Sidebar - Compact Professional Design\n   ============================================ */\n\n/* CSS Variables - Simplified Color Scheme */\n:root {\n  --sidebar-bg: #ffffff;\n  --sidebar-bg-hover: #e0f2fe;\n  --sidebar-active: #87ceeb;\n  --sidebar-active-light: rgba(135, 206, 235, 0.15);\n  --sidebar-text: #000000;\n  --sidebar-text-muted: #4a5568;\n  --sidebar-border: rgba(135, 206, 235, 0.3);\n  --sidebar-transition: all 0.2s ease;\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --sidebar-width: 260px; /* Initial sidebar width */\n}\n\n/* ============================================\n   Mobile Toggle Button\n   ============================================ */\n.mobileToggle {\n  display: none;\n  position: fixed;\n  top: 0.75rem;\n  left: 0.75rem;\n  z-index: 1001;\n  background: var(--light-sky-blue);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: var(--sidebar-transition);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.mobileToggle:hover {\n  background: #6bb6d4;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.mobileToggle:active {\n  transform: scale(0.95);\n}\n\n@media (max-width: 768px) {\n  .mobileToggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n/* ============================================\n   Mobile Overlay\n   ============================================ */\n.mobileOverlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  animation: fadeIn 0.2s ease-in-out;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* ============================================\n   Main Sidebar Container\n   ============================================ */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 260px;\n  background: var(--sidebar-bg);\n  color: var(--sidebar-text);\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid var(--sidebar-border);\n  transition: var(--sidebar-transition);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.sidebarCollapsed {\n  width: 70px;\n}\n\n/* ============================================\n   Sidebar Header\n   ============================================ */\n.sidebarHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 0.875rem;\n  border-bottom: 1px solid var(--sidebar-border);\n  background: var(--sidebar-bg);\n  min-height: 60px;\n}\n\n.logoSection {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n  flex: 1;\n  overflow: hidden;\n}\n\n.logoText {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--sidebar-text);\n  margin: 0;\n  letter-spacing: -0.25px;\n  white-space: nowrap;\n}\n\n.logoSubtext {\n  font-size: 0.6875rem;\n  color: var(--sidebar-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.collapseButton {\n  background: transparent;\n  border: 1px solid var(--sidebar-border);\n  color: var(--sidebar-text);\n  border-radius: 0.375rem;\n  padding: 0.375rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: var(--sidebar-transition);\n  min-width: 32px;\n  min-height: 32px;\n}\n\n.collapseButton:hover {\n  background: var(--sidebar-bg-hover);\n  border-color: var(--light-sky-blue);\n}\n\n.collapseButton:active {\n  transform: scale(0.95);\n}\n\n/* ============================================\n   Navigation Content\n   ============================================ */\n.navContent {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0.75rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.navContent::-webkit-scrollbar {\n  width: 4px;\n}\n\n.navContent::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.navContent::-webkit-scrollbar-thumb {\n  background: var(--sidebar-border);\n  border-radius: 2px;\n}\n\n.navContent::-webkit-scrollbar-thumb:hover {\n  background: var(--light-sky-blue);\n}\n\n.navSection {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n  padding: 0 0.625rem;\n}\n\n/* ============================================\n   Menu Item\n   ============================================ */\n.menuItem {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.625rem 0.875rem;\n  color: var(--sidebar-text);\n  text-decoration: none;\n  border-radius: 0.375rem;\n  transition: var(--sidebar-transition);\n  position: relative;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.menuItem::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--light-sky-blue);\n  transform: scaleY(0);\n  transition: transform 0.2s ease;\n}\n\n.menuItem:hover {\n  background: var(--sidebar-bg-hover);\n  color: var(--sidebar-text);\n}\n\n.menuItem:hover::before {\n  transform: scaleY(1);\n}\n\n.menuItemActive {\n  background: var(--sidebar-active-light);\n  color: var(--sidebar-text);\n  font-weight: 600;\n}\n\n.menuItemActive::before {\n  transform: scaleY(1);\n}\n\n.menuItemCollapsed {\n  justify-content: center;\n  padding: 0.625rem;\n}\n\n.menuIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  min-width: 18px;\n  color: var(--sidebar-text);\n}\n\n.menuItemActive .menuIcon {\n  color: var(--light-sky-blue);\n}\n\n.menuLabel {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.activeIndicator {\n  position: absolute;\n  right: 0.625rem;\n  width: 6px;\n  height: 6px;\n  background: var(--light-sky-blue);\n  border-radius: 50%;\n}\n\n/* ============================================\n   Sidebar Section (Accordion)\n   ============================================ */\n.sidebarSection {\n  margin-bottom: 0.25rem;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  background: transparent;\n  border: none;\n  color: var(--sidebar-text);\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: var(--sidebar-transition);\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-align: left;\n  position: relative;\n}\n\n.sectionHeader:hover {\n  background: var(--sidebar-bg-hover);\n}\n\n.sectionHeaderExpanded {\n  background: var(--sidebar-bg-hover);\n}\n\n.sectionHeaderCollapsed {\n  justify-content: center;\n  padding: 0.625rem;\n}\n\n.sectionHeader:disabled {\n  cursor: default;\n}\n\n.sectionIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  min-width: 18px;\n  color: var(--sidebar-text);\n}\n\n.sectionLabel {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sectionChevron {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n  color: var(--sidebar-text-muted);\n}\n\n.sectionHeaderExpanded .sectionChevron {\n  transform: rotate(90deg);\n}\n\n.sectionContent {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.25s ease;\n  padding-left: 0.375rem;\n  margin-top: 0.125rem;\n}\n\n.sectionContentExpanded {\n  max-height: 2000px;\n  padding-left: 0.375rem;\n}\n\n.sectionContent .menuItem {\n  padding-left: 2.25rem;\n  font-size: 0.8125rem;\n  font-weight: 400;\n}\n\n.sectionContent .menuItemActive {\n  font-weight: 500;\n}\n\n/* ============================================\n   Sidebar Footer\n   ============================================ */\n.sidebarFooter {\n  padding: 0.75rem 0.625rem;\n  border-top: 1px solid var(--sidebar-border);\n  background: var(--sidebar-bg);\n}\n\n.logoutButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.625rem;\n  width: 100%;\n  padding: 0.75rem 0.875rem;\n  background: var(--light-red);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--sidebar-transition);\n}\n\n.logoutButton:hover {\n  background: #ff5252;\n}\n\n.logoutButton:active {\n  transform: scale(0.98);\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .sidebar {\n    width: 240px;\n  }\n\n  .sidebarCollapsed {\n    width: 65px;\n  }\n\n  .logoText {\n    font-size: 1.125rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .mobileToggle {\n    display: flex;\n    top: 0.625rem;\n    left: 0.625rem;\n  }\n\n  .mobileOverlay {\n    display: block;\n  }\n\n  .sidebar {\n    width: 260px;\n    max-width: 85vw;\n    transform: translateX(-100%);\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .sidebarMobileOpen {\n    transform: translateX(0);\n  }\n\n  .sidebarCollapsed {\n    width: 260px;\n    max-width: 85vw;\n  }\n\n  .sidebarHeader {\n    padding: 0.875rem 0.75rem;\n    min-height: 55px;\n  }\n\n  .logoText {\n    font-size: 1.125rem;\n  }\n\n  .navContent {\n    padding: 0.625rem 0;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .navSection {\n    padding: 0 0.5rem;\n  }\n\n  .menuItem {\n    padding: 0.75rem 0.875rem;\n    font-size: 0.875rem;\n    touch-action: manipulation;\n  }\n\n  .sectionHeader {\n    padding: 0.75rem 0.875rem;\n    font-size: 0.875rem;\n    touch-action: manipulation;\n  }\n\n  .sectionContent .menuItem {\n    padding-left: 2.5rem;\n  }\n\n  .collapseButton {\n    min-width: 28px;\n    min-height: 28px;\n    padding: 0.25rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .sidebar {\n    width: 100%;\n    max-width: 280px;\n  }\n\n  .mobileToggle {\n    top: 0.5rem;\n    left: 0.5rem;\n    padding: 0.5rem;\n    width: 40px;\n    height: 40px;\n  }\n\n  .sidebarHeader {\n    padding: 0.75rem 0.625rem;\n    min-height: 50px;\n  }\n\n  .logoText {\n    font-size: 1rem;\n  }\n\n  .logoSubtext {\n    font-size: 0.625rem;\n  }\n\n  .navContent {\n    padding: 0.5rem 0;\n  }\n\n  .menuItem {\n    padding: 0.625rem 0.75rem;\n    font-size: 0.8125rem;\n  }\n\n  .sectionHeader {\n    padding: 0.625rem 0.75rem;\n    font-size: 0.8125rem;\n  }\n\n  .logoutButton {\n    padding: 0.625rem 0.75rem;\n    font-size: 0.8125rem;\n  }\n\n  .collapseButton {\n    min-width: 24px;\n    min-height: 24px;\n    padding: 0.25rem;\n  }\n}\n\n/* ============================================\n   Accessibility & Animations\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Focus states for keyboard navigation */\n.menuItem:focus-visible,\n.sectionHeader:focus-visible,\n.collapseButton:focus-visible,\n.logoutButton:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n/* Print styles */\n@media print {\n  .sidebar {\n    display: none;\n  }\n\n  .mobileToggle {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileToggle": `Sidebar_mobileToggle__+vi9J`,
	"mobileOverlay": `Sidebar_mobileOverlay__oCEWt`,
	"fadeIn": `Sidebar_fadeIn__JFH-L`,
	"sidebar": `Sidebar_sidebar__y9l62`,
	"sidebarCollapsed": `Sidebar_sidebarCollapsed__f57kE`,
	"sidebarHeader": `Sidebar_sidebarHeader__VcE0q`,
	"logoSection": `Sidebar_logoSection__Q3vO9`,
	"logoText": `Sidebar_logoText__aDX9V`,
	"logoSubtext": `Sidebar_logoSubtext__bksI3`,
	"collapseButton": `Sidebar_collapseButton__wzb8+`,
	"navContent": `Sidebar_navContent__zSbRD`,
	"navSection": `Sidebar_navSection__MrBC6`,
	"menuItem": `Sidebar_menuItem__diVxf`,
	"menuItemActive": `Sidebar_menuItemActive__kbq3X`,
	"menuItemCollapsed": `Sidebar_menuItemCollapsed__a0lvM`,
	"menuIcon": `Sidebar_menuIcon__4MF8g`,
	"menuLabel": `Sidebar_menuLabel__U7TaE`,
	"activeIndicator": `Sidebar_activeIndicator__-Bf-h`,
	"sidebarSection": `Sidebar_sidebarSection__tCTA2`,
	"sectionHeader": `Sidebar_sectionHeader__AnQWG`,
	"sectionHeaderExpanded": `Sidebar_sectionHeaderExpanded__19YGx`,
	"sectionHeaderCollapsed": `Sidebar_sectionHeaderCollapsed__EIWaC`,
	"sectionIcon": `Sidebar_sectionIcon__-0twO`,
	"sectionLabel": `Sidebar_sectionLabel__bjzdA`,
	"sectionChevron": `Sidebar_sectionChevron__AfkFz`,
	"sectionContent": `Sidebar_sectionContent__g5zZp`,
	"sectionContentExpanded": `Sidebar_sectionContentExpanded__5gZ+l`,
	"sidebarFooter": `Sidebar_sidebarFooter__ia3Ij`,
	"logoutButton": `Sidebar_logoutButton__hHI1p`,
	"sidebarMobileOpen": `Sidebar_sidebarMobileOpen__YVvhL`
};
export default ___CSS_LOADER_EXPORT___;
